import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Assest/images/logo/logo.png";
import { FaCartShopping, FaUser, FaChevronDown } from "react-icons/fa6";
import { FaBars, FaTimes } from "react-icons/fa";
import SignInimg from "../Assest/images/icons/1.svg";
import SignInimg1 from "../Assest/images/icons/2.svg";
import SignInimg2 from "../Assest/images/icons/3.svg";
import SignInimg3 from "../Assest/images/icons/4.svg";

const Header = () => {
  const [showSearchPopup, setShowSearchPopup] = useState(false);

  const [openMenu, setOpenMenu] = useState(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [contactLensesDropdown, setContactLensesDropdown] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [profileDropdown, setProfileDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const updateCartCount = () => {
      const cart = JSON.parse(sessionStorage.getItem("cart")) || [];
      const totalQty = cart.reduce((total, item) => total + item.qty, 0);
      setCartCount(totalQty);
    };

    const checkLoginStatus = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);
    };

    updateCartCount();
    checkLoginStatus();

    // Listen for storage changes
    window.addEventListener("storage", updateCartCount);
    window.addEventListener("storage", checkLoginStatus);
    window.addEventListener("cartUpdated", updateCartCount);
    window.addEventListener("loginStatusChanged", checkLoginStatus);

    return () => {
      window.removeEventListener("storage", updateCartCount);
      window.removeEventListener("storage", checkLoginStatus);
      window.removeEventListener("cartUpdated", updateCartCount);
      window.removeEventListener("loginStatusChanged", checkLoginStatus);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("profiledata");

    setIsLoggedIn(false);
    setProfileDropdown(false);
    navigate("/");
  };

  const toggleProfileDropdown = () => {
    setProfileDropdown(!profileDropdown);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/category?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <>
      {/* ================= TOP BAR ================= */}
      <div className="top-bar d-md-block d-none">
        <div className="top-bar-inner">
          <div className="help">
            <span className="text-white fs-13">
              <i className="icon-headphone"></i> Need Help?
            </span>
            <a className="phone fs-13"> Call +91-9891316160</a>
          </div>

          <div className="headerSearch_topsearch__oY7aK ">
            <form onSubmit={handleSearchSubmit}>
              <input
                className="header_search headerSearch_searchField__5XWi1"
                placeholder="Search for Eyeglasses, Sunglasses and more..."
                type="text"
                name="search"
                id="header_search"
                autoComplete="off"
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <div className="headerSearch_vLine__wy9_n"></div>
            </form>
          </div>

          <div className="top-links header_right__ZHweY">
            <ul className="topheader-nav">
              <li className="nav-item">
                {isLoggedIn ? (
                  <div className="profile-section position-relative">
                    <button
                      className="nav-link d-flex align-items-center header_account__IqLSr"
                      onClick={toggleProfileDropdown}
                    >
                      <FaUser className="me-2" />
                      Profile
                      <FaChevronDown className="ms-1" />
                    </button>
                    {profileDropdown && (
                      <ul
                        className="profile-dropdown position-absolute bg-white border shadow-sm p-0 m-0"
                        style={{
                          top: "100%",
                          left: 0,
                          zIndex: 99999,
                          minWidth: "150px",
                        }}
                      >
                        <li className="list-unstyled">
                          <Link
                            to="/profile"
                            className="d-block px-3 py-2 text-decoration-none text-dark"
                            onClick={() => setProfileDropdown(false)}
                          >
                            Edit Profile
                          </Link>
                        </li>
                        <li className="list-unstyled">
                          <Link
                            to="/profile"
                            className="d-block px-3 py-2 text-decoration-none text-dark"
                            onClick={() => setProfileDropdown(false)}
                          >
                            My Orders
                          </Link>
                        </li>
                        <li className="list-unstyled">
                          <Link
                            to="/profile"
                            className="d-block px-3 py-2 text-decoration-none text-dark"
                            onClick={() => setProfileDropdown(false)}
                          >
                            Address
                          </Link>
                        </li>
                        <li className="list-unstyled">
                          <button
                            className="d-block w-100 text-start px-3 py-2 border-0 bg-transparent text-dark"
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </li>
                      </ul>
                    )}
                  </div>
                ) : (
                  <Link
                    to="/login"
                    className="nav-link d-flex align-items-center header_account__IqLSr"
                  >
                    <img src={SignInimg} alt="" />
                    Sign In
                  </Link>
                )}
              </li>
              <li className="nav-item">
                <Link
                  to="/track-order"
                  className="nav-link d-flex align-items-center header_account__IqLSr"
                >
                  <img src={SignInimg1} alt="" />
                  Track Order
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className="nav-link d-flex align-items-center header_account__IqLSr"
                >
                  <img src={SignInimg2} alt="" /> Find A Store
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* top-2 */}
      <div className="top-bar d-md-none d-block">
        <div className="top-bar-inner">
          <div className="help-1">
            <span className="text-white fs-13">
              <i className="icon-headphone"></i> Need Help?
            </span>
            <a className="phone fs-13"> Call +91-9891316160</a>
          </div>

          {showSearchPopup && (
            <div className="search-popup-overlay">
              <div className="search-popup-box">
                {/* CLOSE */}
                <button
                  className="search-popup-close"
                  onClick={() => setShowSearchPopup(false)}
                >
                  ✕
                </button>

                {/* YOUR SEARCH CODE */}
                <div className="headerSearch_topsearch__oY7aK">
                  <form onSubmit={handleSearchSubmit}>
                    <input
                      className="header_search headerSearch_searchField__5XWi1"
                      placeholder="Search for Eyeglasses, Sunglasses and more..."
                      type="text"
                      name="search"
                      id="header_search"
                      autoComplete="off"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      autoFocus
                    />
                    <div className="headerSearch_vLine__wy9_n"></div>
                  </form>
                </div>
              </div>
            </div>
          )}

          <div className="top-links header_right__ZHweY">
            <ul className="topheader-nav">
              <li>
                {" "}
                <button
                  className="search-icon-btn"
                  onClick={() => setShowSearchPopup(true)}
                >
                  <img src={SignInimg3} alt="" />
                </button>
              </li>
              <li className="nav-item">
                {isLoggedIn ? (
                  <div className="profile-section position-relative">
                    <Link
                      to="./Profile"
                      className="nav-link d-flex align-items-center header_account__IqLSr"
                      onClick={toggleProfileDropdown}
                    >
                      <FaUser className="me-2" />
                      {/* Profile */}
                    </Link>
                  </div>
                ) : (
                  <Link
                    to="/login"
                    className="nav-link d-flex align-items-center header_account__IqLSr"
                  >
                    <img src={SignInimg} alt="" />
                  </Link>
                )}
              </li>
              <li className="nav-item">
                <Link
                  to="/track-order"
                  className="nav-link d-flex align-items-center header_account__IqLSr"
                >
                  <img src={SignInimg1} alt="" />
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/login"
                  className="nav-link d-flex align-items-center header_account__IqLSr"
                >
                  <img src={SignInimg2} alt="" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* ================= HEADER ================= */}
      <header className="header">
        <div className="header-logo">
          <Link to="/">
            <img src={Logo} alt="logo" />
          </Link>
        </div>

        <div className="header-inner">
          {/* NAV */}
          <ul className={`nav ${mobileMenu ? "nav-open" : ""}`}>
            <li>
              <Link
                to="/category?type=eyeglasses"
                className="nav-link"
                onClick={() => setMobileMenu(false)}
              >
                Eyeglasses
              </Link>
            </li>

            <li>
              <Link
                to="/category?type=sunglasses"
                className="nav-link"
                onClick={() => setMobileMenu(false)}
              >
                Sunglasses
              </Link>
            </li>

            <li>
              <Link
                to="/category?type=power-sunglasses"
                className="nav-link"
                onClick={() => setMobileMenu(false)}
              >
                Power Sunglasses
              </Link>
            </li>

            <li>
              <Link
                to="/category?type=computer-glasses"
                className="nav-link"
                onClick={() => setMobileMenu(false)}
              >
                Computer Glasses
              </Link>
            </li>
             <li>
                <Link
                  to="/category?type=cricket-glasses"
                  className="nav-link"
                  onClick={() => setMobileMenu(false)}
                >
                  Cricket
                </Link>
              </li>
              
            <li className="nav-item dropdown contct-dropdown">
              <Link
                to="/category?type=contact-lenses"
                className="nav-link"
                onClick={() => setMobileMenu(false)}
              >
                Contact Lenses
              </Link>

             
              {/* <a
                href="javascript:void(0);"
                className="nav-link dropdown-toggle"
                onClick={() => setContactLensesDropdown(!contactLensesDropdown)}
              >
                Contact Lenses
              </a> */}

              {/* {contactLensesDropdown && (
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to="/category?type=contact-lenses"
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenu(false);
                        setContactLensesDropdown(false);
                      }}
                    >
                      All Contact Lenses
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/category?type=contact-lenses&lens-type=daily-disposable"
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenu(false);
                        setContactLensesDropdown(false);
                      }}
                    >
                      Daily Disposable
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/category?type=contact-lenses&lens-type=monthly"
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenu(false);
                        setContactLensesDropdown(false);
                      }}
                    >
                      Monthly
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/category?type=contact-lenses&brand=bausch-lomb"
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenu(false);
                        setContactLensesDropdown(false);
                      }}
                    >
                      BAUSCH & LOMB
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/category?type=contact-lenses&brand=johnson-johnson"
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenu(false);
                        setContactLensesDropdown(false);
                      }}
                    >
                      JOHNSON & JOHNSON
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/category?type=contact-lenses&brand=cooper-vision"
                      className="dropdown-item"
                      onClick={() => {
                        setMobileMenu(false);
                        setContactLensesDropdown(false);
                      }}
                    >
                      COOPER VISION
                    </Link>
                  </li>
                </ul>
              )} */}
            </li>
          </ul>
        </div>
        <div className="header-inner">
          {/* NAV */}
          <ul className={`nav ${mobileMenu ? "nav-open" : ""}`}>
            <li className="position-relative d-lg-block d-none">
              <Link to="/cart" className="nav-link">
                <FaCartShopping className="fs-20" />
                {cartCount > 0 && (
                  <span className="cart-count">{cartCount}</span>
                )}
              </Link>
            </li>
          </ul>
        </div>

        {/* TOGGLE BUTTON (MOBILE) */}

        <div className="mobile_header ms-auto">
          <div className="position-relative d-lg-none d-block ms-auto me-4">
            <Link to="/cart" className="nav-link">
              <FaCartShopping className="fs-16" />
              {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
            </Link>
          </div>
          <div
            className="menu-toggle  "
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            {mobileMenu ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
